import React, { Component } from "react";
import { Flex } from "grid-styled";
import { withTheme } from "styled-components";
import Media from "react-media";

import FirstPage from "./FirstPage";
import SecondPage from "./SecondPage";
import { ScrollView, Relative } from "../globals";

class AnimationController extends Component {
    state = {
        innerHeight: window.innerHeight + "px"
    };

    componentDidMount() {
        this.updateInnerHeight();
        window.addEventListener("resize", this.updateInnerHeight);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateInnerHeight);
    }

    updateInnerHeight = () => {
        this.setState({ innerHeight: window.innerHeight + "px" });
    };

    render() {
        return (
            <Media query={`(min-width: ${this.props.theme.breakpoints[1]})`}>
                {matches =>
                    matches ? (
                        <Flex flex={1} style={{ minHeight: 0 }}>
                            <FirstPage nBooks={this.props.books.length} />
                            <SecondPage books={this.props.books} />
                        </Flex>
                    ) : (
                        <Flex flex={1} style={{ minHeight: 0 }}>
                            <Flex flexDirection="column" flex={1} bg="#EBEBEB">
                                <Flex
                                    flexDirection="column"
                                    flex={1}
                                    style={{ minHeight: 0 }}
                                >
                                    <Flex
                                        flexDirection="column"
                                        flex={1}
                                        bg="#EBEBEB"
                                        style={{ minHeight: 0 }}
                                    >
                                        <ScrollView>
                                            <Relative>
                                                <FirstPage
                                                    nBooks={
                                                        this.props.books.length
                                                    }
                                                />
                                                <SecondPage
                                                    books={this.props.books}
                                                />
                                            </Relative>
                                        </ScrollView>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    )
                }
            </Media>
        );
    }
}

export default withTheme(AnimationController);



// WEBPACK FOOTER //
// ./src/components/AnimationController/index.js